// Phase 3 (B1): shared chart palette. These hex values match the example PDF the
// client provided (1003.1_Etang-B_Répartition-24_20260402.pdf) — light mint/teal for
// the current period and a saturated cobalt blue for the prior period. Donut and
// object-vs-immeuble charts reuse the same primaries and add neutral greys for
// category fills.
//
// Keep this file the single source of truth: all 3 chart components and any future
// chart import from here so that brand updates only need to touch one place.

const PHASE_3_PALETTE = {
  current: '#B3E5DA',   // mint/teal — main period (e.g. 2024)
  prior:   '#2A2EE6',   // cobalt blue — compare period (e.g. 2023)
  text:    '#00033F',   // deep navy — labels, axis ticks
  muted:   '#9CA3AF',   // grey — axis lines, gridlines
  donut:   [
    '#B3E5DA', // mint (Chauffage / Bureau bucket)
    '#2A2EE6', // cobalt
    '#1E1B4B', // deep indigo
    '#C7D2FE', // pale lilac
    '#9CA3AF', // grey
    '#F4F4F5', // near-white (Entretien/blanks)
  ],
};

export { PHASE_3_PALETTE };
